import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from "react-bootstrap";

interface OverlayMessageProps {
  message: string;
  onClose?: () => void;
  showDropdown?: boolean;
  dropdownOptions?: string[];
  onDropdownChange?: (value: string) => void;
}

const OverlayMessage: React.FC<OverlayMessageProps> = ({
  message,
  onClose,
  showDropdown = false,
  dropdownOptions = [],
  onDropdownChange,
}) => {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState<string>(dropdownOptions[0] || '');
  const dropdownRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    if (showDropdown && dropdownRef.current) {
      dropdownRef.current.focus();
    }
  }, [showDropdown]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };

  const handleDropdownChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setSelectedValue(value);
    if (onDropdownChange) {
      onDropdownChange(value);
    }
  };

  return (
    <div className='warehouse-popup-container'
   
    >
      <div className='warehouse-pop-up'
      
      >
        <button className='warehouse-popup-close'
          
          onClick={handleClose}
        >
          &#x2715;
        </button>

        {/* <Modal.Header
          closeButton
        ></Modal.Header> */}

        <p style={{ fontSize: '1.2rem' , margin: 0 }}>{message}</p>
      </div>
    </div>
  );
};

export default OverlayMessage;